import { de as dateFnsLocaleDe } from "date-fns/locale";
import { de as core } from "@xbs/wx-core-locales";
export const de = {
    ...core,
    dateFnsLocale: dateFnsLocaleDe,
    scheduler: {
        "New Event": "Neuer Eintrag",
        "Add description": "Beschreibung",
        "Create event": "Neuer Eintrag",
        "Edit event": "Ändern",
        "Delete event": "Löschen",
        "Event name": "Name",
        "Start date": "Start",
        "End date": "Ende",
        "All day": "Den ganzen Tag",
        "No events": "Keine Ereignisse",
        Type: "Typ",
        Description: "Beschreibung",
        Today: "Heute",
        Day: "Tag",
        Week: "Woche",
        Month: "Monat",
        Year: "Jahr",
        Timeline: "Zeitleiste",
        Agenda: "Agenda",
        Calendars: "Kalender",
        hourFormat: "H",
        minuteFormat: "mm",
        monthFormat: "EEE",
        dateFormat: "EEE, d",
        agendaDateFormat: "MMMM d EEEE",
        unassignFormat: "d MMM yyyy",
        Color: "Farbe",
        Delete: "Löschen",
        Edit: "Ändern",
        Calendar: "Kalender",
        New: "Neuer",
        Name: "Name",
        Save: "Speichern",
        Add: "Hinzufügen",
        confirmDelete: "Der Eintrag wird gelöscht",
        confirmUnsaved: "Du hast nicht gespeicherte Änderungen! Möchten Sie sie verwerfen?",
        "Repeat event": "Ereignis wiederholen",
        Never: "Niemals",
        Every: "Jeden",
        Workdays: "An Werktagen",
        After: "Nach",
        "On date": "Am tag",
        events: "veranstaltungen",
        "recurring event": "wiederkehrendes ereignis",
        all: "Alle ereignis",
        future: "Diese und folgende ereignis",
        only: "Diese ereigni",
        recurringActionError: "Das Startdatum darf nicht nach dem wiederkehrenden Ablaufdatum liegen",
        assignees: "Abtretungsempfänger",
        "Recurring events": "Wiederkehrende ereignisse",
        "Single events": "Einzelereignisse",
        recurringEveryMonthDay: "Jedes {date}",
        recurringEveryMonthPos: "Jeden {pos} {weekDay}",
        recurringEveryYearDay: "Jedes {date} von {month}",
        recurringEveryYearPos: "Jeden {pos} {weekDay} von {month}",
    },
};
//# sourceMappingURL=de.js.map